import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import useInvoices from '../hooks/useInvoices';
import InvoiceGrid from "../shared/InvoiceGrid";

const InvoicePage: React.FC = () => {
  const { data, status } = useInvoices();
  return (
    <InvoiceGrid data={data?.index} status={status} />
  );
};
export default withAuthenticationRequired(InvoicePage);
